import { useCallback, useEffect, useState } from 'react';
import { apiService } from '../../services/api.service';

export interface MemberContestStats {
  totalDistance: number;
  averagePace: number;
  // Admin only: flagged activities not yet dismissed.
  suspiciousActivityCount?: number;
}

// Per-member contest totals for one team, keyed by userId. Members with no counted
// activity are absent from the leaderboard, so callers treat a missing key as zero.
export const useTeamMemberContestStats = (contestId: string | undefined, teamId: string | undefined) => {
  const [statsByUser, setStatsByUser] = useState<Record<string, MemberContestStats>>({});
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!contestId || !teamId) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const response = await apiService.getTeamMemberLeaderboard(contestId, teamId, 1000);
      const next: Record<string, MemberContestStats> = {};
      for (const m of response.members || []) {
        next[m.userId] = { totalDistance: m.totalDistance || 0, averagePace: m.averagePace || 0, suspiciousActivityCount: m.suspiciousActivityCount };
      }
      setStatsByUser(next);
    } catch (error) {
      console.error('Error fetching team member stats:', error);
      setStatsByUser({});
    } finally {
      setLoading(false);
    }
  }, [contestId, teamId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { statsByUser, loading, reload };
};
